import { ShapePolygonPlusIcon } from './ShapePolygonPlusIcon';

/**
 * author: Kai Faust
 * id CFE631FF-AAD1-49D9-BA22-84BAC90B8787
 * name shape-polygon-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-polygon-plus.svg
 * tags
 * - Shape 
 */
export const ShapePolygonAddIcon = ShapePolygonPlusIcon;
export default ShapePolygonAddIcon